export default __webpack_public_path__ + "static/media/product-vector-2.7c4e6500.png";